import { FunctionComponent, useState } from 'react';
import { Box, createStyles, makeStyles, Theme } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import ChatInput from '../Chat/ChatInput';
import NewPhoneChatHeader from './NewPhoneChatHeader';
import { EmptyMessage } from 'model/ProspectMessage';
import { PhoneSearchResult } from 'model/PhoneSearch';
import { SaveNewMessage } from 'actions/prospectMessage/prospectMessageActions';
import { FieldError } from '@spike/model';

export interface ChatProps {
    marketplaceId: number;
    handleGoBack: () => void;
    handleClickOnPhone: (phoneSearchResult: PhoneSearchResult) => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            height: '100%'
        },
        chatDisplayContainerNoHeader: {
            width: '100%',
            height: '70%'
        },
        chatDisplayContainer: {
            flexGrow: 1,
            width: '100%',
            maxWidth: '100%'
        },
        chatInputContainer: {
            width: '100%',
            zIndex: 99,
            borderTop: '#D4D4D4 1px solid'
        }
    })
);

const NewPhoneChat: FunctionComponent<ChatProps> = props => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [errors, setErrors] = useState<Array<FieldError>>([]);

    const [newMessage, setNewMessage] = useState<EmptyMessage>({
        message: '',
        phone: ''
    });

    const sendMessageHandler = () => {
        if (newMessage) {
            dispatch(SaveNewMessage(newMessage, props.marketplaceId));
        }
    };

    const changeMessageHandler = (text: string) => {
        setNewMessage(prev => ({
            ...prev,
            message: text,
            phone: prev?.phone ?? ''
        }));
    };

    return (
        <Box className={classes.root}>
            <>
                <NewPhoneChatHeader
                    newMessage={newMessage}
                    setNewMessage={setNewMessage}
                    handleClickOnPhone={props.handleClickOnPhone}
                    onBackButton={() => props.handleGoBack()}
                    errors={errors}
                    setErrors={setErrors}
                />
                <Box className={classes.chatDisplayContainer} />
                <Box className={classes.chatInputContainer}>
                    <ChatInput
                        isActive={errors.length === 0}
                        messageText={newMessage.message as string}
                        onMessageChange={changeMessageHandler}
                        onSendMessage={sendMessageHandler}
                    />
                </Box>
            </>
        </Box>
    );
};

export default NewPhoneChat;
